import { useLocalStorageState } from 'ahooks';
export function useLocalStorageStateOfJankIssue() {
    return useLocalStorageState('CsJankIssue', {
        defaultValue: {
            appId: '',
            baseIssueId: '',
            compareIssueId: '',
        },
        listenStorageChange: true,
    });
}
export function useLocalStorageStateOfAiChatBot() {
    return useLocalStorageState('CsAiChatBot', {
        defaultValue: {
            conversationId: '',
        },
        listenStorageChange: true,
    });
}
const AI_CHAT_BOT_EX_DEFAULT = {
    conversationId: '',
    clawChatId: '',
    workspaceSelection: 'ai_agent',
};
/** 合并 localStorage 状态，保证 conversationId / workspaceSelection 始终为 string（避免 spread undefined 导致 TS2345） */
export function mergeAiChatBotExStorage(prev, patch) {
    const base = prev ?? AI_CHAT_BOT_EX_DEFAULT;
    return {
        conversationId: patch.conversationId !== undefined ? patch.conversationId : base.conversationId,
        clawChatId: patch.clawChatId !== undefined ? patch.clawChatId : base.clawChatId,
        workspaceSelection: patch.workspaceSelection !== undefined ? patch.workspaceSelection : base.workspaceSelection,
    };
}
export function useLocalStorageStateOfAiChatBotEx() {
    const [storageData, setStorageData] = useLocalStorageState('CsAiChatBotEx', {
        defaultValue: AI_CHAT_BOT_EX_DEFAULT,
        listenStorageChange: true,
    });
    /** 类型安全的局部更新，避免 setStorageData 函数式更新在 TS 下推断为 Partial */
    const patchStorageData = (patch) => {
        setStorageData((prev) => mergeAiChatBotExStorage(prev, patch));
    };
    return [storageData, setStorageData, patchStorageData];
}
export function useLocalStorageStateOfFieldTopStats() {
    return useLocalStorageState('CsFieldTopStats', {
        defaultValue: {
            pcSelectedFields: [],
        },
        listenStorageChange: true,
    });
}
export function useLocalStorageStateOfReportTableColumns() {
    return useLocalStorageState('CsReportTableColumns', {
        defaultValue: {
            appIdToReportTableColumns: {},
        },
        listenStorageChange: true,
    });
}
export function useLocalStorageStateOfAiSearchHistory() {
    return useLocalStorageState('CsAiSearchHistory', {
        defaultValue: [],
        listenStorageChange: true,
    });
}
